import { BsCalendar2Week } from "react-icons/bs";
import { MdClose } from "react-icons/md"; // Для хрестика
import clsx from "clsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import css from "./CalendarPeriodSelector.module.css";
import { useState } from "react";
import uk from "date-fns/locale/uk";
import { registerLocale } from "react-datepicker";

registerLocale("uk", uk);

export default function CalendarPeriodSelector({
  renderInModal,
  handleInputChangeBeg,
  handleInputChangeEnd,
  periodStartData,
  periodEndData,
  isSingle = false,
  noFuture,
}) {
  const [isOpenBeg, setIsOpenBeg] = useState(false);
  const [isOpenEnd, setIsOpenEnd] = useState(false);
  const [isDateSelectedBeg, setIsDateSelectedBeg] = useState(false); // Стан для визначення, чи вибрана дата

  const handleIconClickBeg = () => setIsOpenBeg(prev => !prev);
  const handleIconClickEnd = () => setIsOpenEnd(prev => !prev);

  const handleDateChange = date => {
    if (isSingle) {
      handleInputChangeBeg(date);
      setIsDateSelectedBeg(true); // Якщо дата вибрана, хрестик з'являється
      setIsOpenBeg(false);
    } else {
      handleInputChangeBeg(date);
      setIsOpenBeg(false);
    }
  };

  // Функція для скидання дати
  const handleResetDateBeg = () => {
    handleInputChangeBeg(null);
    setIsDateSelectedBeg(false); // Хрестик приховується
  };

  return (
    <div className={css.calendarContainer} data-tour-inworkgi="step-4">
      <p className={css.periodTitle}>{!isSingle && "З"}</p>
      <div
        className={clsx(css.dateWrapper, {
          [css.dateWrapperModal]: renderInModal,
        })}
      >
        <DatePicker
          className={css.periodInput}
          selected={periodStartData}
          onChange={date => handleDateChange(date)}
          dateFormat="dd/MM/yyyy"
          open={isOpenBeg}
          onClickOutside={() => setIsOpenBeg(false)}
          popperClassName={css.leftdatePickerDropdown}
          locale="uk"
          maxDate={noFuture ? new Date() : ""}
        />
        <div className={css.calendarBtn}>
          {isDateSelectedBeg && (
            <MdClose className={css.iconClose} onClick={handleResetDateBeg} />
          )}
          <BsCalendar2Week
            className={css.icon}
            onClick={handleIconClickBeg}
            data-tour-periodselector="step-2"
          />
        </div>
      </div>

      {!isSingle && (
        <>
          <p className={css.periodTitle}>По</p>
          <div
            data-tour-periodselector="step-3"
            className={clsx(css.dateWrapper, {
              [css.dateWrapperModal]: renderInModal,
            })}
          >
            <DatePicker
              className={css.periodInput}
              selected={periodEndData}
              onChange={date => {
                handleInputChangeEnd(date);
                setIsOpenEnd(false);
              }}
              dateFormat="dd/MM/yyyy"
              open={isOpenEnd}
              onClickOutside={() => setIsOpenEnd(false)}
              popperClassName={css.datePickerDropdown}
              locale="uk"
              maxDate={noFuture ? new Date() : ""}
            />
            <div className={css.calendarBtn}>
              <BsCalendar2Week
                className={css.icon}
                onClick={handleIconClickEnd}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
